module.exports = __webpack_public_path__ + "static/media/god_of_war.7e67daff.png";